import request from '@/utils/request'

// 上传文件
export function uploadFile(data,accessToken) {
  const formData = new FormData()
  formData.append('file', data)
  return request({
    url: '/sys/file/upload/element',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': accessToken
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/upload.js